import Image from 'next/image';
import React from 'react';

import Stars from '@/components/design/stars';

type CardProps = {
  avatar: string;
  name: string;
  timeAgo: string;
  rating: number;
  text: string;
};

export default function TestimonialCard({
  avatar,
  name,
  timeAgo,
  rating,
  text,
}: CardProps) {
  return (
    // Removed hardcoded width and added flex-shrink-0 for consistent sizing in grid
    <article className="flex flex-col gap-4 rounded-xl bg-gradient-to-r from-gray-950/50 via-gray-950/[3%] to-gray-950/50 backdrop-blur[22] p-6 text-sm text-gray-100 flex-shrink-0">
      {/* Header */}
      <header className="flex items-center gap-3">
        <Image
          src={avatar}
          alt={name}
          width={48}
          height={48}
          className="h-12 w-12 rounded-full object-cover"
        />
        <div>
          <p className="text-p1 font-semibold leading-none">{name}</p>
          <p className="text-p1 text-gray-400">{timeAgo}</p>
        </div>
      </header>

      {/* Rating row */}
      <Stars rating={rating} size={14} />

      {/* Quote */}
      <p className="text-p2 text">“{text}”</p>
    </article>
  );
}